import { PButtonPure, PText, PFlexItem } from '@porsche-design-system/components-react'
import clsx from 'clsx'
import React from 'react'
import { Link } from 'react-router-dom'

import { TEXTS } from '../../../config/texts'
import { PortalContext } from '../../../utils/PortalContext'

import styles from './actions.module.css'

type Props = {
  appData: any
  className: string
}

const Actions = ({ appData, className }: Props) => {
  const { setOpenDrawer, setDrawerContent, setDrawerData } = React.useContext(PortalContext)
  const [routeToReporting, setRouteToReporting] = React.useState('')

  const openDetailsInDrawer = (event: React.MouseEvent) => {
    event.stopPropagation()
    setDrawerData(appData)
    setOpenDrawer(true)
    setDrawerContent('DetailsApp')
  }

  const openNewSubAppInDrawer = (event: React.MouseEvent) => {
    event.stopPropagation()
    setDrawerData(appData)
    setOpenDrawer(true)
    setDrawerContent('NewSubApp')
  }

  const openReporting = (event: React.MouseEvent) => {
    event.stopPropagation()
  }

  React.useEffect(() => {
    if (appData.appInformation.type === 'app') {
      setRouteToReporting('/?application=' + appData.appInformation.id)
    }
    if (appData.appInformation.type === 'subApp') {
      setRouteToReporting(
        '/?application=' + appData.appInformation.parents.idApp + '&subapp=' + appData.appInformation.id
      )
    }
    if (appData.appInformation.type === 'module') {
      setRouteToReporting(
        '/?application=' +
          appData.appInformation.parents.idApp +
          '&subapp=' +
          appData.appInformation.parents.idSubApp +
          '&module=' +
          appData.appInformation.id
      )
    }
  }, [appData])

  return (
    <PFlexItem className={clsx(className)}>
      <Link to={routeToReporting}>
        <PButtonPure size='small' weight='thin' icon='chart' onClick={openReporting} hideLabel>
          {TEXTS.ACTIONS_SHOW_DETAILS}
        </PButtonPure>
      </Link>
      <PButtonPure size='small' weight='thin' onClick={openDetailsInDrawer} hideLabel>
        {TEXTS.ACTIONS_SHOW_DETAILS}
      </PButtonPure>
      {appData.appInformation.type !== 'module' && (
        <div className={styles.menuAdd}>
          <PButtonPure hideLabel size='small' icon='plus' onClick={openNewSubAppInDrawer}>
            {TEXTS.ACTIONS_ADD}
          </PButtonPure>
          <div className={clsx(styles.menu)}>
            <PText className={styles.menuItem} onClick={openNewSubAppInDrawer}>
              {TEXTS.ACTIONS_ADD_SUB}
            </PText>
          </div>
        </div>
      )}
    </PFlexItem>
  )
}

export default Actions
